<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/flowConfig01List' }">流向商业配置</el-breadcrumb-item>
                <el-breadcrumb-item>流向商业配置{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'commodityFlowConfig01Edit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.status = 1;
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                product_rid: {
                    request_uri: 'dropdownProducts',
                    request_params: { type_code: [11, 91] },
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown'
                },
                business_rid: {
                    request_uri: 'searchAccounts',
                    title: '一级商业',
                    ref: 'business_rid_ref',
                    default_option_key: 'business_option',
                    type: 'search_select'
                },
                supplier_rid: {
                    request_uri: 'searchAccounts',
                    title: '供方',
                    ref: 'supplier_rid_ref',
                    default_option_key: 'supplier_option',
                    type: 'search_select'
                },
                sup_supplier_rid: {
                    request_uri: 'searchAccounts',
                    title: '上级供方',
                    ref: 'sup_supplier_rid_ref',
                    default_option_key: 'sup_supplier_option',
                    type: 'search_select'
                },
                partner_rid: {
                    request_uri: 'dropdownPartners',
                    title: '合作方',
                    ref: 'partner_rid_ref',
                    type: 'dropdown'
                },
                credential_rid: {
                    request_uri: 'dropdownFlowCredentials',
                    title: '凭据',
                    ref: 'credential_rid_ref',
                    display_name: 'code',
                    type: 'dropdown'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date'
                }
            };
        },
        initFormRule() {
            this.rules = {
                business_rid: [{ required: true, message: '请输入一级商业搜索', trigger: 'blur' }],
                supplier_rid: [{ required: true, message: '请输入供方搜索', trigger: 'blur' }],
                sup_supplier_rid: [{ required: false, message: '请输入上级供方搜索', trigger: 'blur' }],
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                partner_rid: [{ required: true, message: '请选择合作方', trigger: 'blur' }],
                credential_rid: [{ required: true, message: '请选择凭据', trigger: 'blur' }],
                start_date: [{ required: true, message: '请选择开始日期', trigger: 'blur' }],
                end_date: [{ required: true, message: '请选择结束日期', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id || '';
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                business_rid: this.data.business_rid || '',
                supplier_rid: this.data.supplier_rid || '',
                sup_supplier_rid: this.data.sup_supplier_rid || '',
                product_rid: this.data.product_rid || '',
                partner_rid: this.data.partner_rid || '',
                credential_rid: this.data.credential_rid || '',
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                business_option: { rid: this.data.business_rid || '', name: this.data.business || '' },
                supplier_option: { rid: this.data.supplier_rid || '', name: this.data.supplier || '' },
                sup_supplier_option: { rid: this.data.sup_supplier_rid || '', name: this.data.sup_supplier || '' }
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('dataList')).commodity_flow_config01;
            processColDataToEdit(
                temp,
                this,
                {
                    white: ['start_date', 'end_date']
                },
                {
                    business: 'business_rid',
                    supplier: 'supplier_rid',
                    sup_supplier: 'sup_supplier_rid',
                    product: 'product_rid',
                    partner: 'partner_rid',
                    credential: 'credential_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/flowConfig01List' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .commodityFlowConfig01Detail(this.queryParams)
                .then((res) => {
                    // 编辑或复制页面，如果审批状态不是草稿或审批中，默认为审批中
                    if (!in_array(res.data.approval_status, [1, 2])) {
                        res.data.approval_status = 2;
                    }

                    this.data = res.data;

                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'commodityFlowConfig01Update';
            } else {
                uri = 'commodityFlowConfig01Insert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>